import isEmpty from 'lodash.isempty';
import moment from 'moment';

export const objectIsChanged = <T>(obj1: T, obj2: Partial<T>): boolean => {
  if (isEmpty(obj2)) {
    return false;
  }
  let result = false;
  for (const key in obj2) {
    if (
      key === 'dateOfBirth' &&
      moment(obj2[key] as Date).format('DD/MM/YYYY') !==
        moment(obj1[key] as Date).format('DD/MM/YYYY')
    ) {
      result = true;
      continue;
    }
    if (obj2[key] !== obj1[key]) {
      result = true;
    }
  }
  return result;
};
